var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-tel-input-vuetify',{staticClass:"mb-n1",attrs:{"outlined":"","label":_vm.label,"dense":"","rules":_vm.rules,"defaultCountry":_vm.country,"disabledFetchingCountry":true},on:{"input":_vm.handlePhone},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}})
}
var staticRenderFns = []

export { render, staticRenderFns }